import Layout from "../layout/Layout";
import { RouteComponentProps } from "@reach/router";
import RecallsWizard from "../recallWizard/RecallsWizard";

export default function CreateRecallsPage(props: RouteComponentProps) {
    return (
        <Layout pageTitle="Request A Recall" showBackButton={false} showBreadcrumb={false} canScroll={true}>
            <RecallsWizard />
        </Layout>
    )
}